const api = {
    baseUrl: 'https://bixart.quqo.com',
    nfts: '/nfts',
    nftShowcases: '/nft_showcases',
    authors: '/authors',
    authorsSales: '/author_ranks',
    hotCollections: '/hot-collections',
    contactUs: '/contact-forms'
}

export default api;